define('viewModels/privileged/qm/CustomerJourneyListView',[
    'lib/knockout',
    'lib/lodash4',
    'viewModels/ViewModel'
], function (
    ko,
    _,
    ViewModel
) {
    'use strict';

    var JOURNEY_SUMMARY_COLUMNS = [{
            label: 'customerJourneyDetailsList.participantName',
            id: 'participantName'
        },
        {
            label: 'customerJourneyDetailsList.mediaType',
            id: 'mediaType'
        }
    ];

    /**
     * @param  {string} conversationId
     * @param  {JourneyContext[]} journeyContexts
     */
    var CustomerJourneyListView = ViewModel.extend(function (journeyContexts, navigateToCustomerJourneySession) {
        var self = this;
        var unwrappedJourneyContexts = ko.unwrap(journeyContexts);

        var buildRow = function (journeyContext) {
            return _.assign({
                navigateToCustomerJourneySession: navigateToCustomerJourneySession.bind(self, journeyContext.journeyCustomerSessionId)
            }, journeyContext);
        };

        // Add the appropriate information to the dataTable
        self.dataGrid = ko.observable({
            columns: JOURNEY_SUMMARY_COLUMNS,
            rows: ko.observableArray(_.map(unwrappedJourneyContexts, buildRow))
        });
    });

    return CustomerJourneyListView;
});

